/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithCacheKeyItemRequestBuilder, WithCacheKeyItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/payments/worldpay/callback
 */
export interface CallbackRequestBuilder extends BaseRequestBuilder<CallbackRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.payments.worldpay.callback.item collection
     * @param cacheKey Cache key for retrieving callback state (AppUrl, OrganizationId, CustomerNumber, IsDefault)
     * @returns {WithCacheKeyItemRequestBuilder}
     */
     byCacheKey(cacheKey: string) : WithCacheKeyItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const CallbackRequestBuilderUriTemplate = "{+baseurl}/api/payments/worldpay/callback";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CallbackRequestBuilderNavigationMetadata: Record<Exclude<keyof CallbackRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCacheKey: {
        requestsMetadata: WithCacheKeyItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["cacheKey"],
    },
};
/* tslint:enable */
/* eslint-enable */
